import {
	PHARMACY_DISPENSE_LABELS_LIST_REQUEST,
	PHARMACY_DISPENSE_LABELS_LIST_SUCCESS,
	PHARMACY_DISPENSE_LABELS_LIST_FAILURE
} from '../../../constants';

const initialState = {
	data: null,
	loading: false,
	error: null,
	type: null
};

const dispenseLabelListReducer = (state = initialState, action) => {
	switch (action.type) {
		case PHARMACY_DISPENSE_LABELS_LIST_REQUEST:
			return {
				...state,
				loading: true,
				data: null,
				error: null,
				type: action.types
			};
		case PHARMACY_DISPENSE_LABELS_LIST_SUCCESS:
			return {
				...state,
				loading: false,
				data: action.payload,
				type: action.types,
				error: null
			};
		case PHARMACY_DISPENSE_LABELS_LIST_FAILURE:
			return {
				...state,
				loading: false,
				error: action.payload,
				type: action.types,
				data: null,
			};
		default:
			return state;
	}
};

export default dispenseLabelListReducer;
